// Typ dla logu
type LogLevel = "info" | "success" | "warning" | "error";

interface AppNavigationLog {
	id: string;
	timestamp: number;
	level: LogLevel;
	category: string;
	message: string;
	details?: Record<string, unknown>;
	source?: "deep-link" | "onesignal" | "internal";
	route?: string;
}

// Global log store - będzie zbierać logi z procesu nawigacji aplikacji
export class AppNavigationLogger {
	private static logs: AppNavigationLog[] = [];
	private static listeners: Array<(logs: AppNavigationLog[]) => void> = [];
	private static maxLogs = 200;

	static log(
		level: LogLevel,
		category: string,
		message: string,
		details?: Record<string, unknown>,
		source?: "deep-link" | "onesignal" | "internal",
		route?: string
	) {
		const log: AppNavigationLog = {
			id: `${Date.now()}_${Math.random()}`,
			timestamp: Date.now(),
			level,
			category,
			message,
			details,
			source,
			route,
		};

		this.logs.unshift(log); // Najnowsze na górze
		if (this.logs.length > this.maxLogs) {
			this.logs = this.logs.slice(0, this.maxLogs);
		}

		this.notifyListeners();
	}

	static subscribe(listener: (logs: AppNavigationLog[]) => void) {
		this.listeners.push(listener);
		listener(this.logs); // Wyślij aktualne logi od razu
		return () => {
			this.listeners = this.listeners.filter((l) => l !== listener);
		};
	}

	private static notifyListeners() {
		this.listeners.forEach((listener) => listener([...this.logs]));
	}

	static clear() {
		this.logs = [];
		this.notifyListeners();
	}

	static getLogs() {
		return [...this.logs];
	}
}

// Skróty dla łatwiejszego użycia
export const appNavigationLog = {
	info: (
		category: string,
		message: string,
		details?: Record<string, unknown>,
		source?: "deep-link" | "onesignal" | "internal",
		route?: string
	) => AppNavigationLogger.log("info", category, message, details, source, route),
	success: (
		category: string,
		message: string,
		details?: Record<string, unknown>,
		source?: "deep-link" | "onesignal" | "internal",
		route?: string
	) => AppNavigationLogger.log("success", category, message, details, source, route),
	warning: (
		category: string,
		message: string,
		details?: Record<string, unknown>,
		source?: "deep-link" | "onesignal" | "internal",
		route?: string
	) => AppNavigationLogger.log("warning", category, message, details, source, route),
	error: (
		category: string,
		message: string,
		details?: Record<string, unknown>,
		source?: "deep-link" | "onesignal" | "internal",
		route?: string
	) => AppNavigationLogger.log("error", category, message, details, source, route),
};

